<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="form">
    <nb-card-header
      ><h4>
        {{ "dialogs.website.titleCreate" | translate }}
      </h4></nb-card-header
    >
    <nb-card-body>
      <nb-form-field>
        <label for="type" class="label col-sm-3 col-form-label">Typ</label>

        <nb-select
          formControlName="type"
          [status]="showInputError('type') ? 'danger' : 'basic'"
        >
          <nb-option value="urls">
            {{ "enums.websiteType.urls" | translate }}
          </nb-option>
          <nb-option value="sitemap">
            {{ "enums.websiteType.sitemap" | translate }}
          </nb-option>
          <nb-option value="recursive-urls">
            {{ "enums.websiteType.recursive-urls" | translate }}
          </nb-option>
        </nb-select>
        <div class="info">
          <p *ngIf="form.get('type')?.value === 'urls'">
            <b>{{ "enums.websiteType.urls" | translate }}:</b>
            {{ "dialogs.website.infoUrls" | translate }}
          </p>
          <p *ngIf="form.get('type')?.value === 'sitemap'">
            <b>{{ "enums.websiteType.sitemap" | translate }}:</b>
            {{ "dialogs.website.infoSitemap" | translate }}
          </p>
          <p *ngIf="form.get('type')?.value === 'recursive-urls'">
            <b>{{ "enums.websiteType.recursive-urls" | translate }}:</b>
            {{ "dialogs.website.infoRecursive" | translate }}
          </p>
        </div>
      </nb-form-field>

      <nb-form-field>
        <label for="urls" class="label col-sm-3 col-form-label">
          {{ "input.url.label" | translate }}
        </label>
        <div class="col-sm-9">
          <input
            type="urls"
            nbInput
            fullWidth
            id="urls"
            placeholder="{{ 'input.url.placeholder' | translate }}"
            formControlName="urls"
            [status]="showInputError('urls') ? 'danger' : 'basic'"
          />
        </div>

        <!-- show invalid email error message -->
        <div *ngIf="showInputError('urls')" class="error-message">
          {{ "input.url.error" | translate }}
        </div>
      </nb-form-field>

      <nb-form-field>
        <label for="refresh_cycle" class="label col-sm-3 col-form-label">
          {{ "input.refreshRate.label" | translate }}
        </label>

        <nb-select
          formControlName="refresh_cycle"
          [status]="showInputError('refresh_cycle') ? 'danger' : 'basic'"
        >
          <nb-option value="NEVER">{{
            "enums.websiteRefreshRate.NEVER" | translate
          }}</nb-option>
          <nb-option value="DAILY">{{
            "enums.websiteRefreshRate.DAILY" | translate
          }}</nb-option>
          <nb-option value="WEEKLY">{{
            "enums.websiteRefreshRate.WEEKLY" | translate
          }}</nb-option>
          <nb-option value="MONTHLY">{{
            "enums.websiteRefreshRate.MONTHLY" | translate
          }}</nb-option>
          <nb-option value="YEARLY">{{
            "enums.websiteRefreshRate.YEARLY" | translate
          }}</nb-option>
          <!-- <nb-option value="CHANGED">CHANGED</nb-option>  -->
        </nb-select>
      </nb-form-field>

      <!-- show warning message when crawler is running -->
      <app-info-badge
        *ngIf="isCrawlerRunning && !loading"
        message="dialogs.website.crawlerRunning"
        type="warning"
      ></app-info-badge>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.close" | translate }}
      </button>
      <button
        type="submit"
        nbButton
        status="primary"
        [nbSpinner]="loading || isCrawlerRunning"
        [disabled]="this.form.invalid || this.loading || isCrawlerRunning"
      >
        {{ "buttons.add" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
